/**
 * Поиск ссылок в тексте — правило общее для бота и админки.
 *
 * Бот по нему решает, принимать ли заявку, админка — что сделать
 * кликабельным. Разойдись эти правила, человек получил бы заявку,
 * принятую с «ссылкой», которую в админке нельзя открыть.
 */

/**
 * Только http и https.
 *
 * Схемы вроде `javascript:` и `data:` ссылками здесь не считаются: в
 * админке щелчок по такой строке выполнил бы чужой код, а текст заявки
 * пишет посторонний человек.
 */
const LINK_SOURCE = 'https?://[^\\s<>"\']+';

/** Новое выражение на каждый вызов: у общего сохраняется позиция поиска. */
export function linkPattern(): RegExp {
  return new RegExp(LINK_SOURCE, 'gi');
}

/** Есть ли в тексте хотя бы одна ссылка. */
export function containsLink(source: string): boolean {
  return new RegExp(LINK_SOURCE, 'i').test(source);
}
